import  { useState, useEffect, useContext } from "react";
import {
    Typography, TextField, Button,
    FormControl, InputLabel, Select, MenuItem,
    Autocomplete, FormHelperText
} from "@mui/material";
import { reducerContext } from "../../../../contextApi's/contextApi's";
import snackError from "../../../../helpers/snackError";
import { httpRequest } from "../../../../ui-utils/api";
import { backendHosts, apiUrl } from "../../../../ui-utils/apiConfig";
import ReactQuill, { Quill } from "react-quill";
import QuillResizeImage from "quill-resize-image";
import 'react-quill/dist/quill.snow.css';
import axios from "axios";

Quill.register("modules/resize", QuillResizeImage);
const Size = Quill.import("attributors/style/size");
Size.whitelist = ["10px", "12px", "14px", "16px", "18px", "20px", "24px", "32px", "48px"];
Quill.register(Size, true);

const Faqs = () => {
    const modules = {
        toolbar: {
            container: [
                [{ header: [1, 2, 3, false] }],
                [{ size: Size.whitelist }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["link", "image", "video"],
                [{ align: [] }],
                ["clean"],
            ]
        },
        resize: { locale: {} }
    };

    const { state, dispatch } = useContext(reducerContext);
    const { faqCategories, faqSubCategories, faqs } = state;

    const [operation, setOperation] = useState("create");
    const [selectedFaq, setSelectedFaq] = useState(null);

    const [question, setQuestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [subCategoryId, setSubCategoryId] = useState('');
    const [errors, setErrors] = useState({});

    const isEdit = operation === 'edit';
    const isDelete = operation === 'delete';

    useEffect(() => {
        if (categoryId) {
            (async () => {
                try {

                    const result = await axios.get(`${backendHosts.ADMIN}${apiUrl.faqCategories}/${categoryId}`)
                    // const result = await httpRequest({
                    //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqCategories}/${categoryId}`,
                    //     method: "get",
                    //     instance: "instanceOne",
                    // });
                    if (result.data?.status === 200) {
                        dispatch({ type: 'SET_FAQ_SUB_CATEGORIES', payload: result.data?.data?.subcategories });
                    }
                } catch (error) {
                    console.log("Error while fetching subcategories list:", error)
                    dispatch({ type: 'SET_SHOW_ERROR', payload: true });
                    dispatch({ type: 'SET_ERROR', payload: error.error });
                    dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError });
                }
            })();
        }
    }, [categoryId]);

    useEffect(() => {
        (async () => {
            try {

                const res = await axios.get(`${backendHosts.ADMIN}${apiUrl.faqs}`)
                // const res = await httpRequest({
                //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqs}`,
                //     method: "get",
                //     instance: "instanceOne",
                // });
                dispatch({ type: 'SET_FAQS', payload: res.data?.faqResults })
            } catch (error) {
                console.error("Error fetching FAQs:", error);
                dispatch({ type: 'SET_SHOW_ERROR', payload: true });
                dispatch({ type: 'SET_ERROR', payload: error.error });
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError });
            }
        })();
    }, []);

    useEffect(() => {
        if (selectedFaq) {
            setQuestion(selectedFaq.question || '');
            setAnswer(selectedFaq.answer || '');
            setCategoryId(selectedFaq.category?.id || '');
            setSubCategoryId(selectedFaq.subcategory?.id || '')
        } else {
            setQuestion('');
            setAnswer('');
            setCategoryId('');
            setSubCategoryId('');
        }
    }, [selectedFaq]);

    const validate = () => {
        const newErrors = {};
        if (!question.trim()) {
            newErrors.question = "Question is required";
        } else if (!answer.trim()) {
            newErrors.answer = "Answer is required";
        } else if (!categoryId) {
            newErrors.categoryId = "Category is required";
        } else if (!subCategoryId) {
            newErrors.subCategoryId = "Sub Category is required";
        }
        return newErrors;
    };

    const handleSubmit = async () => {
        const errs = validate();
        if (Object.keys(errs).length > 0) {
            setErrors(errs);
            return;
        }

        const payload = {
            question,
            answer,
            category_id: String(categoryId),
            subcategory_id: String(subCategoryId)
        };

        try {

            let url = isEdit
                ? `${backendHosts.ADMIN}${apiUrl.faqs}/${selectedFaq.id}`
                : `${backendHosts.ADMIN}${apiUrl.faqs}`;
            let method = isEdit ? "put" : "post";

            const res = await axios[method](url, payload);
            // const res = await httpRequest({
            //     endPoint: isEdit ? `${backendHosts.ADMIN_REPORT}${apiUrl.faqs}/${selectedFaq.id}` : `${backendHosts.ADMIN_REPORT}${apiUrl.faqs}`,
            //     method: isEdit ? "put" : "post",
            //     instance: "instanceOne",
            //     requestBody: payload
            // });

            if (res.data?.status === 200 || res.data?.status === 201) {
                dispatch({ type: isEdit ? 'UPDATE_FAQ' : 'ADD_FAQ', payload: res.data?.faqResult });
                dispatch({ type: 'SET_SHOW_ERROR', payload: true });
                dispatch({ type: 'SET_ERROR', payload: res.data?.message });
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc });

                setSelectedFaq(null);
                setQuestion('');
                setAnswer('');
                setCategoryId('');
                setSubCategoryId('');
                setErrors({});
            }
        } catch (err) {
            console.error("Error submitting FAQs:", err)
            dispatch({ type: 'SET_SHOW_ERROR', payload: true });
            dispatch({ type: 'SET_ERROR', payload: err.error });
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError });
        }
    };

    const handleDelete = async () => {
        if (!selectedFaq) return;

        try {

            const res = await axios.delete(`${backendHosts.ADMIN}${apiUrl.faqs}/${selectedFaq.id}`)
            // const res = await httpRequest({
            //     endPoint: `${backendHosts.ADMIN_REPORT}${apiUrl.faqs}/${selectedFaq.id}`,
            //     method: "delete",
            //     instance: "instanceOne"
            // });

            if (res.data?.status === 200) {
                dispatch({ type: 'DELETE_FAQ', payload: res.data?.faqResult});
                dispatch({ type: 'SET_SHOW_ERROR', payload: true });
                dispatch({ type: 'SET_ERROR', payload: res.data?.message });
                dispatch({ type: 'SET_MY_SNACK', payload: snackError.mySucc });
                setSelectedFaq(null);
            }
        } catch (err) {
            console.error("Error deleting FAQs:", err)
            dispatch({ type: 'SET_SHOW_ERROR', payload: true });
            dispatch({ type: 'SET_ERROR', payload: err.error });
            dispatch({ type: 'SET_MY_SNACK', payload: snackError.myError });
        }
    };

    return (
        <>
            <Typography variant="h6" fontWeight="bold">FAQs</Typography>

            <FormControl fullWidth margin="normal">
                <InputLabel>Operation</InputLabel>
                <Select value={operation} label="Operation" onChange={(e) => {
                    setOperation(e.target.value);
                    setSelectedFaq(null);
                    setErrors({});
                }}>
                    <MenuItem value="create">Create</MenuItem>
                    <MenuItem value="edit">Edit</MenuItem>
                    <MenuItem value="delete">Delete</MenuItem>
                </Select>
            </FormControl>

            {(isEdit || isDelete) && (
                <Autocomplete
                    options={faqs}
                    getOptionLabel={(option) => option.question}
                    value={selectedFaq}
                    onChange={(e, val) => setSelectedFaq(val)}
                    renderInput={(params) => <TextField {...params} label="Select FAQ" margin="normal" autoComplete="new-password" />}
                    
                />
            )}

            {!isDelete && (
                <>
                    <TextField
                        label="Question"
                        fullWidth
                        margin="normal"
                        value={question}
                        onChange={(e) => setQuestion(e.target.value)}
                        error={!!errors.question}
                        helperText={errors.question}
                        autoComplete="new-password"
                    />

                    <Typography variant="subtitle2" sx={{ mt: 2, ml: 1 }}>Answer:</Typography>
                    <div style={{ border: errors.answer ? '1px solid red' : '1px solid #ccc', borderRadius: 4 }}>
                        <ReactQuill
                            value={answer}
                            onChange={setAnswer}
                            modules={modules}
                            style={{ fontFamily: "Cardiuma-M" }}
                        />
                    </div>
                    {errors.answer && <FormHelperText error sx={{ ml: 2 }}>{errors.answer}</FormHelperText>}

                    <FormControl fullWidth margin="normal" error={!!errors.categoryId}>
                        <InputLabel>Category</InputLabel>
                        <Select
                            label="Category"
                            value={categoryId}
                            onChange={(e) => setCategoryId(e.target.value)}
                        >
                            <MenuItem value="">Select</MenuItem>
                            {faqCategories.map((cat) => (
                                <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{errors.categoryId}</FormHelperText>
                    </FormControl>

                    <FormControl fullWidth margin="normal" error={!!errors.subCategoryId}>
                        <InputLabel>Sub Category</InputLabel>
                        <Select
                            label="Sub Category"
                            value={subCategoryId}
                            onChange={(e) => setSubCategoryId(e.target.value)}
                        >
                            <MenuItem value="">Select</MenuItem>
                            {faqSubCategories.map((sub) => (
                                <MenuItem key={sub.id} value={sub.id}>{sub.name}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{errors.subCategoryId}</FormHelperText>
                    </FormControl>
                </>
            )}

            {operation === 'create' && (
                <Button onClick={handleSubmit} variant="contained" sx={{ mt: 2, mb: 3 }}>
                    Create FAQ
                </Button>
            )}
            {operation === 'edit' && selectedFaq && (
                <Button onClick={handleSubmit} variant="contained" color="primary" sx={{ mt: 2, mb: 3 }}>
                    Update FAQ
                </Button>
            )}
            {operation === 'delete' && selectedFaq && (
                <Button onClick={handleDelete} variant="contained" color="error" sx={{ mt: 2, mb: 3 }}>
                    Delete FAQ
                </Button>
            )}
        </>
    );
};

export default Faqs;
